export enum MappingTypeConstants {
  CriteriaSourceDocument = "criteria_source_document",
  Global = "global",
}
